export const canvasRailCopy = {
  empty: {
    title: "Nothing on this canvas yet",
    description: "Add context from connectors or upload files to get started.",
    cta: "Add context",
  },
  noCanvas: {
    title: "Open a canvas",
    description: "Canvas contents appear here when you are viewing a board.",
  },
} as const;
